import { spring, interpolate } from 'remotion';
import { Crown, TrendingUp, Users } from 'lucide-react';
import { THEME, getScale } from '../../themes/brand';
import type { BrollComponentProps } from './registry';

interface WinnerProps {
  title?: string;
  metrics?: { label: string; value: number; suffix?: string; icon?: string }[];
}

export const WinnerCard: React.FC<BrollComponentProps> = ({ frame, fps, height, durationInFrames, props }) => {
  const s = getScale(height);
  const data = (props || {}) as WinnerProps;
  const dur = durationInFrames;
  const title = data.title || 'YOU WIN!';
  const metrics = data.metrics || [
    { label: 'Engagement Rate', value: 4.2, suffix: '%' },
    { label: 'Followers', value: 12400 },
  ];

  const entrance = spring({ frame, fps, config: { damping: 10 }, durationInFrames: Math.max(10, Math.round(dur * 0.2)) });
  const crownBounce = Math.sin(frame * 0.15) * 8;

  return (
    <div style={{
      width: '100%', height: '100%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: THEME.colors.bg, fontFamily: THEME.font.family,
    }}>
      <div style={{
        backgroundColor: THEME.colors.bgCard,
        border: `${Math.max(2, 3 * s)}px solid ${THEME.colors.warning}`,
        borderRadius: THEME.radius.xl * s,
        padding: `${THEME.spacing.xl * s}px ${THEME.spacing.xxl * s}px`,
        textAlign: 'center',
        opacity: entrance, transform: `scale(${entrance})`,
        boxShadow: `0 0 ${80 * s}px ${THEME.colors.warning}50`,
      }}>
        <div style={{ transform: `translateY(${crownBounce}px)` }}>
          <Crown size={64 * s} color={THEME.colors.warning} fill={THEME.colors.warning} style={{ filter: `drop-shadow(0 0 ${20 * s}px ${THEME.colors.warning})` }} />
        </div>

        <div style={{
          color: THEME.colors.text, fontSize: THEME.font.subtitle * s * 1.2,
          fontWeight: THEME.font.weight.bold, marginTop: THEME.spacing.md * s, letterSpacing: 4 * s,
        }}>
          {title}
        </div>

        <div style={{ display: 'flex', gap: THEME.spacing.xxl * s, marginTop: THEME.spacing.lg * s, justifyContent: 'center' }}>
          {metrics.map((m, i) => {
            const countStart = Math.round(dur * 0.15);
            const countEnd = Math.round(dur * 0.7);
            const val = m.suffix === '%'
              ? Math.floor(interpolate(frame, [countStart, countEnd], [0, m.value], { extrapolateRight: 'clamp', extrapolateLeft: 'clamp' }) * 10) / 10
              : Math.floor(interpolate(frame, [countStart, countEnd], [0, m.value], { extrapolateRight: 'clamp', extrapolateLeft: 'clamp' }));

            const MetricIcon = i === 0 ? TrendingUp : Users;

            return (
              <div key={m.label} style={{ textAlign: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: THEME.spacing.sm * s }}>
                  <MetricIcon size={32 * s} color={THEME.colors.accent} />
                  <span style={{
                    color: THEME.colors.accent, fontSize: THEME.font.title * s * 1.3,
                    fontWeight: THEME.font.weight.black,
                  }}>
                    {m.suffix === '%' ? val.toFixed(1) + '%' : val.toLocaleString()}
                  </span>
                </div>
                <div style={{ color: THEME.colors.textMuted, fontSize: THEME.font.label * s, marginTop: THEME.spacing.xs * s }}>
                  {m.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
